<template>
  <div class="creativeTable">
    <heading type="h4">Editable Fields <small>{{ subHeading }}</small></heading>
    <slot-table id="creativeTable" :data="tableData" :columns="table.columns" @toggleCheckboxes="toggleParentCheckboxes" :child="(this.subHeading.length > 0)">
      <template slot="is_editable" slot-scope="props">
          <span><checkbox :id="genId('checkbox', props.item.id)" v-model="props.item.is_editable"
                          :value="props.item.is_editable"/></span>
      </template>
      <template slot="type" slot-scope="props">
        <span class="text-capitalize">{{ props.item.type }}</span>
      </template>
      <!-- <template slot="limit" slot-scope="props">
          <span><field v-if="props.item.type === 'string'" type="number" v-model="props.item.limit"
                       :value="props.item.limit" /></span>
      </template>
      <template slot="is_hard_limit" slot-scope="props">
          <span>
            <switch-button v-if="props.item.type === 'string'" :id="genId('switch', props.item.id)"
                           v-model="props.item.is_hard_limit" :on="props.item.is_hard_limit"/></span>
      </template> -->
      <!-- <template slot="editableActions" slot-scope="props" > -->
        <!-- <div class="buttonsWrapper">
              <span v-if="props.item.editableActions && ((props.item.default_values && props.item.default_values.length > 1) || (props.item.type === 'image' && props.item.image_preview))">
                <button-cta :onClick="()=>togglePreviewRow(props.item)" class="btn btn-info btn-xs">
                  <i class="fa fa-chevron-right" :id="genId('chevron', props.item.id)" aria-hidden="true"></i>
                </button-cta>
              </span>
        </div> -->
      <!-- </template> -->

    </slot-table>

  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {modalMixin} from '@/mixins/modalMixin'

import {AWS_S3_BUCKET, API_URL} from '@/config'

export default {
  name: 'CreativeTable',
  components: {
    SlotTable,
    ButtonCta,
    Field,
    SwitchButton,
    Checkbox,
    Heading
  },
  mixins: [modalMixin],
  props: {
    tableData: Array,
    type: String,
    subHeading: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    table: {
      columns: {
        is_editable: 'allCheckboxes',
        name: 'Name',
        type: 'Type',
        // limit: 'Limit',
        // is_hard_limit: 'HardLimit',
        defaultValue: 'Default Value'
        // editableActions: ''
      }
    }
  }),
  computed: {},
  methods: {
    toggleParentCheckboxes (toggle) {
      this.$emit('onToggleParentCheckboxes', toggle)
    },
    assetUrl (path) {
      return `${API_URL}${path.charAt(0) === '/' ? path.substring(1) : path}` // need to remove leading slash
    },
    togglePreviewRow (item) {
      let rowId = item.id
      if (this.subHeading.length > 0) {
        rowId += '_child'
      }
      const type = item.type
      const previewRow = `previewRow__${rowId}`
      const chevron = document.getElementById(`chevron_${rowId}`)

      // toggle chevron
      if (chevron.classList.contains('fa-chevron-right')) {
        chevron.classList.remove('fa-chevron-right')
        chevron.classList.add('fa-chevron-down')
      } else {
        chevron.classList.add('fa-chevron-right')
        chevron.classList.remove('fa-chevron-down')
      }

      // if already created lets just toggle hidden class
      if (document.contains(document.getElementById(previewRow))) {
        const row = document.getElementById(previewRow)
        if (this.type === 'after-effects') {
          const img = row.getElementsByTagName('img')[0]
          img.src = `${AWS_S3_BUCKET}${item.image_preview}?ts${Math.round(+new Date() / 1000)}`
        }
        if (row.classList.contains('hidden')) {
          row.className = ''
          return
        }
        row.className = 'hidden'
        return
      }

      const target = document.getElementById(rowId)
      const newElement = document.createElement('tr')
      newElement.id = previewRow
      target.parentNode.insertBefore(newElement, target.nextSibling)
      const cell = newElement.insertCell(0)
      cell.colSpan = '7'
      const defaults = item.default_values
      const path = item.image_preview
      if (defaults && defaults.length) {
        let count = 0
        defaults.forEach((defaultValue) => {
          if (type === 'image') {
            const img = document.createElement('img')
            img.addEventListener('error', (e) => {
              if (count !== 0) {
                e.target.style.display = 'none'
              }
              e.target.src = `https://via.placeholder.com/500x50/2c3247/56ffa2?text=No+Preview+Available`
            })
            if (this.type === 'after-effects') {
              const defaultByMaster = `${item.image_preview_prefix}/${defaultValue.value}`
              img.src = `${AWS_S3_BUCKET}${defaultByMaster.charAt(0) === '/' ? defaultByMaster.substring(1) : defaultByMaster}`
            } else {
              const defaultByMaster = `${item.image_preview_prefix}/${defaultValue.value}`
              img.src = `${API_URL}${defaultByMaster.charAt(0) === '/' ? defaultByMaster.substring(1) : defaultByMaster}`
            }
            img.style.width = '25%'
            img.style.height = '25%'
            cell.appendChild(img)
          } else {
            const p = document.createElement('p')
            p.appendChild(document.createTextNode(`${defaultValue.master}: ${defaultValue.value}`))
            cell.appendChild(p)
          }
          count++
        })
      } else {
        if (type === 'image') {
          const img = document.createElement('img')
          img.style.width = '25%'
          img.style.height = '25%'
          if (this.type === 'after-effects') {
            img.src = `${AWS_S3_BUCKET}${path.charAt(0) === '/' ? path.substring(1) : path}`
            cell.appendChild(img)
          } else {
            img.src = `${API_URL}${path.charAt(0) === '/' ? path.substring(1) : path}`
            cell.appendChild(img)
          }
          img.addEventListener('error', (e) => {
            e.target.src = `https://via.placeholder.com/500/2c3247/56ffa2?text=Loading`
          })
        }
      }

      cell.className = 'creativeTable__preview'
      return cell
    },
    genId (type, id) {
      if (this.subHeading.length > 0) {
        return `${type}_${id}_child`
      }
      return `${type}_${id}`
    }
  }
}
</script>

<style lang="scss">
    .creativeTable {
      &__preview {
        text-align: center;
        img {
          padding: 15px 0;
        }
      }
    }
    .buttonsWrapper{
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      span + span {
        margin-left: 5px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/CreativeTable/creative-table.vue